var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVerifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 130.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-3 {\r\n        font-family: Poppins-Medium, Poppins;\r\n        font-size: 16px;\r\n        font-weight: 500;\r\n      }\r\n\r\n      .cls-3, .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        clip-path: url(#clippath);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,100H0V0h100v100ZM1.92,98.08h96.15V1.92H1.92v96.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.44,86.57h7.72v-36.88h-7.72v36.88ZM80.57,78.87v-37.44h-7.7v-7.69h-35.3v52.83h35.3v-7.69h-27.6v-37.44h27.61v37.43h7.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.15,33.74h-7.72v7.72h7.72v-7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.44,20.93c0,1.74.95,2.38,2.47,2.38h1.4v-1.48h-1.09c-.75,0-1-.26-1-.9v-4.75h2.08v-1.45h-2.08v-2.13h-1.79v2.13h-1.01v1.45h1.01v4.75h0ZM72.83,23.31h2.01l-2.77-4.34,2.77-4.23h-1.85l-1.74,2.91-1.85-2.91h-2.01l2.77,4.36-2.77,4.22h1.85l1.74-2.91,1.85,2.91h0ZM66.42,20.75h-1.91c-.33.67-.93,1.2-2.02,1.2-1.31,0-2.32-.86-2.44-2.27h6.55c.05-.3.06-.57.06-.87,0-2.52-1.73-4.22-4.17-4.22s-4.28,1.73-4.28,4.42,1.82,4.44,4.28,4.44c2.1,0,3.45-1.2,3.94-2.69M62.41,16.09c1.32,0,2.37.84,2.39,2.16h-4.75c.19-1.35,1.15-2.16,2.35-2.16M54.79,23.31h1.76v-5.06c0-2.39-1.51-3.66-3.51-3.66-1.03,0-1.98.42-2.55,1.12v-.98h-1.77v8.57h1.77v-4.79c0-1.57.86-2.38,2.16-2.38s2.15.81,2.15,2.38v4.79h0ZM38.98,21.27l-2.41-6.53h-1.98l3.38,8.43-1.74,4.17h1.84l5.26-12.6h-1.84l-2.5,6.53h0ZM31.59,23.31h1.76v-5.06c0-2.39-1.52-3.66-3.53-3.66-1.25,0-2.46.65-2.99,1.69-.59-1.12-1.73-1.69-3.08-1.69-1.03,0-1.96.42-2.54,1.12v-.98h-1.77v8.57h1.77v-4.79c0-1.57.86-2.38,2.16-2.38s2.15.81,2.15,2.38v4.79h1.76v-4.79c0-1.57.86-2.38,2.16-2.38s2.15.81,2.15,2.38v4.79Z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(17.61 121.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VERIFIER"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerifier);
export default __webpack_public_path__ + "static/media/logo-verifier.2f99c98ded873f1b3f2cd370c68f3258.svg";
export { ForwardRef as ReactComponent };